<template>
  <div class="home">
    <h2 class="title">Login</h2>
    <label for='email'><span>Email</span><br/><input type='email' v-model='email' name='email' id='email' /></label>
    <label for='password'><span>Password</span><br/><input type='password' v-model='password' name='password' id='password' /></label>
    <button type='submit' class="button is-success" v-on:click="doLogin">Login</button>
  </div>
</template>

<style lang="scss" scoped>
  label {
    display : block;
    margin : 0 0 1rem 0;
    & > input {
      width : 20rem;
      border : 1px solid #ddd;
      padding : 0.5rem;
    }
  }
</style>

<script>
export default {
  name: 'login',
  data : function(){
    return {
      email : '',
      password : ''
    }
  },
  methods : {
    doLogin : function(){
      this.callAPI('post', 'users/login', this._data)
        .then((res) => {
          this.$store.commit('updateLoggedInUser', res.data);
          this.$router.push({ name: 'home' });
        })
        .catch((err) => { console.error(err); });
    }
  }
}
</script>